import { useFreeShippingMessagingExperiment } from './useFreeShippingMessagingExperiment';

import { useProductBySlugBasicPDP } from '@/modules/product/hooks/useProductBySlugBasicPDP';
import { useProductBySlugExtendedPDP } from '@/modules/product/hooks/useProductBySlugExtendedPDP';
import { ShippingId } from '@/modules/shipping/types';
import { useCountryHeader } from '@/modules/user/useCountryHeader';

export function useShowPdpFreeShippingMessaging() {
  const countryCode = useCountryHeader();
  const { data: product } = useProductBySlugBasicPDP();
  const { data: productExtended } = useProductBySlugExtendedPDP();

  const isUSDepopShipping =
    product?.shipping_method?.shipping_id === ShippingId.USPS;
  const isEligible =
    productExtended?.is_product_owner === false &&
    countryCode?.toUpperCase() === 'US' &&
    isUSDepopShipping;

  return useFreeShippingMessagingExperiment(isEligible);
}
